export const C2B_ORIGINS = {
  BANNER_HOME: 'bannerHome',
  BANNER_HOME_TO_DEALERS: 'bannerHomeToDealers',
  BANNER_HOME_TO_STANDALONE: 'bannerHomeToStandalone',
  CHAT: 'chat',
  INSTANT_OFFER_LANDING: 'instantOfferLanding',
  PUBLISH_MY_AD: 'publishMyAd',
  PUBLISHED_AD: 'publishedAd',
  STANDALONE: 'standalone',
  STANDALONE_EMPTY_CASE: 'standaloneEmptyCase',
  VEHICLE_APPRAISER: 'vehicleAppraiser',
  POST_LEAD: 'postLead',
  // ff_web_c2b_pro_seller_access_banner
  PRO_SELLER_ACCESS_BANNER_URL: 'https://profesional.coches.net/anunciate-como-profesional/'
}

export const C2B_DEALER_NAMES = {
  BCA: 'BCA',
  TEST_ONLINE: 'Test Online'
}

export const HIT_ORIGINS = {
  appointmentConfirmed: 'cita confirmada'
}

export const IS_PANEL_HOW_TO_PUBLISH_ENABLED = false
export const IS_WHATSAPP_COMMUNICATION_CONSENTS_ENABLED = false

// This is a specific constant for the C2B context since the tenant is not enough to determine the vehicle type in this case, as Milanuncios can be used for both cars and motorcycles
export const VEHICLE_TYPE = 'MOTORCYCLE'

export const PUBLISH_AD_IMAGE_URL = 'illustrations/seller-publish-ad-motos.svg'

export const REQUEST_HELP_URL = 'https://motosnet.zendesk.com/hc/es/requests/new?ticket_form_id=35569759611154'

export const HAS_PREDICTION_SCORE = false
